import React, {FC} from 'react';
import styled from 'styled-components';

import {Plural, Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {useToggle} from '../../../../libs/shared/helpers/src/react/hooks/hookHelpers';
import {CheckBox} from '../../../../libs/shared/ui/src/components/booleanInputs/checkBox';
import {OkCancelDialog} from '../../common/dialogs/okCancelDialog';
import {RescheduleConfirmHandler} from './calendarsGrid';

const StyledCheckboxDiv = styled.div`
  display: flex;

  padding-top: 15px;
`;

const StyledCheckboxTextDiv = styled.div`
  padding-left: 8px;
`;

/*
 * Props.
 */

interface RescheduleCalendarEventDialogProps {
  onRescheduleConfirm: RescheduleConfirmHandler;
  nonResourceGuestCount: number;
  shouldShowNotifyGuestsOption: boolean;
}

/*
 * Component.
 */

export const RescheduleCalendarEventDialog: FC<RescheduleCalendarEventDialogProps> = (props) => {
  const {onRescheduleConfirm, nonResourceGuestCount, shouldShowNotifyGuestsOption} = props;

  const [shouldNotifyGuests, toggleShouldNotifyGuests] = useToggle(true);

  const onConfirmClick = () => onRescheduleConfirm(true, shouldNotifyGuests);
  const onRequestClose = () => onRescheduleConfirm(false);

  return (
    <OkCancelDialog
      title={<Trans id="reschedule-calendar-event-title">Reschedule calendar event</Trans>}
      okButtonLabel={<Trans id="reschedule-calendar-event-confirm">Confirm</Trans>}
      onOkClick={onConfirmClick}
      onRequestClose={onRequestClose}
    >
      {!shouldShowNotifyGuestsOption && (
        <Trans id="reschedule-calendar-event-rescheduled-with-updates">
          This event will be rescheduled and updates will be sent to all attendees.
        </Trans>
      )}
      {shouldShowNotifyGuestsOption && (
        <>
          <Trans id="reschedule-calendar-event-rescheduled">This event will be rescheduled.</Trans>
          <StyledCheckboxDiv>
            <CheckBox onChange={toggleShouldNotifyGuests} isChecked={shouldNotifyGuests} />
            <StyledCheckboxTextDiv>
              <Plural
                id="reschedule-calendar-event-email-guests"
                value={nonResourceGuestCount}
                one="Email guest"
                other="Email guests"
              />
            </StyledCheckboxTextDiv>
          </StyledCheckboxDiv>
        </>
      )}
    </OkCancelDialog>
  );
};
